import Organizations from "entities/Organizations";
import { useState } from "react";
import View from "./View";

const List = () => {
  const [pagination, setPagination] = useState({});
  const filter = { where: {} };

  return (
    <Organizations
      View={View}
      filter={{ ...filter, ...pagination }}
      setValues={setPagination}
      skip={pagination.skip || 0}
    />
  );
};

export default List;
